
export default class NavTreeType {
    static sitesection = 'sitesection';
    static topicref = 'topicref';
    static openApiTag = 'openApiTag';
    static openApiPage = 'openApiPage';
}